import { useField } from "formik";
import { ParameterTypeSelector } from "./ParameterTypeSelector";
import { ParameterTypeInput } from "./ParameterTypeInput";

/**
 * Functional Component: ParameterValueInputByType
 * 
 * This component renders an input field for the parameter value based on the selected parameter type.
 * It includes a selector for the parameter type and an input field that changes based on the type selected.
 * 
 * Props:
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.type - The type of the parameter.
 * @param {string} [props.id="value"] - The ID for the input field (default is "value").
 * @param {Object} rest - Additional properties passed to the input field.
 * 
 * Returns:
 * @returns {JSX.Element} A JSX element containing the parameter type selector and the parameter type input field.
 */
export const ParameterValueInputByType = (
    {type, id = "value",...rest}: any = {}
  ) => {
    const [field,meta,helpers] = useField("type");
    return <>
      <ParameterTypeSelector id="type" elementClass="required" />
      <ParameterTypeInput type={field.value} id={id} {...rest} />
    </>;
  };
